const appVersion = '3.4.6';
const apiSuffix = '/rest/orderer/v5/';
const pingSuffix = '/rest/system/ping';
const logoutSuffix = '/Login/app/SLO';

const readEmmParam = name => {
  if (
    !window.cordova ||
    !window.cordova.plugins ||
    !window.cordova.plugins.EmmAppConfig
  )
    return null;
  return window.cordova.plugins.EmmAppConfig.getValue(name);
};

const isProd = process.env.NODE_ENV === 'production';
const isMobile = process.env.CORDOVA;
const isImprivata =
  isMobile &&
  (process.env.IMPRIVATA || readEmmParam('ssoProvider') === 'Imprivata');
const definedHost = process.env.PAKE_HOST;

const host =
  definedHost || window.location.protocol + '//' + window.location.host;
const authenticatedUrl = isMobile ? host + pingSuffix : null;
const authUrl = authenticatedUrl
  ? process.env.PAKE_IDP
    ? host +
      '/Login/app/DS?entityID=' +
      process.env.PAKE_IDP +
      '/app&LG=fi&url=' +
      authenticatedUrl
    : authenticatedUrl
  : null;
const loggedOutUrl = isMobile ? host + logoutSuffix : null;
const apiUrl = host + apiSuffix;
const logging = !isProd;
const creds = process.env.PAKE_HOST && !isImprivata ? 'omit' : 'include';

const parseUrl = url => {
  const hostMatch = url.match(/^(https?):\/\/([^/:?#]+)(?:[/:?#]|$)/i);
  let hostname;
  let protocol;
  if (hostMatch.length > 2) {
    [, protocol, hostname] = hostMatch;
  } else {
    console.error('Error in getting hostname or protocol from URL', url);
  }
  return { protocol, hostname };
};

let parsed = parseUrl(apiUrl);

const config = {
  appVersion,
  hostname: parsed.hostname,
  protocol: parsed.protocol,
  host,
  loggingEnabled: logging,
  credentialsMode: creds,
  apiUrl: apiUrl,
  authUrl: authUrl,
  authenticatedUrl: authenticatedUrl,
  loggedOutUrl: loggedOutUrl,
  isImprivata: isImprivata,

  // TODO Temp: Should not be in config but instead in js-code of the Imprivata-plugin.
  adUsername: null,
  // adPassword,
  // displayName,
  basicAuthHeader: null,
};

const changeServer = newHost => {
  const oldHost = config.host;
  config.apiUrl = config.apiUrl.replace(oldHost, newHost);
  config.authUrl = config.authUrl.replace(oldHost, newHost);
  config.authenticatedUrl = config.authenticatedUrl.replace(oldHost, newHost);
  config.loggedOutUrl = config.loggedOutUrl.replace(oldHost, newHost);
  let parsedUrl = parseUrl(config.apiUrl);
  config.hostname = parsedUrl.hostname;
  config.protocol = parsedUrl.protocol;
};

const changeAuthProvider = newAuth => {
  config.isImprivata = newAuth === 'Imprivata';
};

// TODO Temp: Should not be in config but instead in js-code of the Imprivata-plugin.
const setBasicAuth = (
  adUsername,
  /*password, displayName,*/ basicAuthHeader
) => {
  config.adUsername = adUsername;
  config.basicAuthHeader = basicAuthHeader;
};

const readEmmConfig = () => {
  const emmServerUrl = readEmmParam('serverUrl');
  if (emmServerUrl) changeServer(emmServerUrl);
  // const emmAuthMethod = readEmmParam('ssoProvider');
  // if (emmAuthMethod) changeAuthProvider(emmAuthMethod);
};

module.exports = {
  config,
  changeServer,
  readEmmConfig,
  changeAuthProvider,
  setBasicAuth,
};
